import { Stack } from '@chakra-ui/react';
import BasicArtistCard from 'components/Artist/BasicArtistCard/BasicArtistCard';
import { ArtistModel } from 'models';

interface ArtistPreviewProps {
  artist: ArtistModel;
}

export default function ArtistPreview({ artist }: ArtistPreviewProps) {
  return (
    <Stack spacing={4} align="center" width="100%">
      <BasicArtistCard artist={artist} titleSize="xl" showButton={false} showAdditionalInfo />
    </Stack>
  );
}
